import { ApplicationFlowTheme } from '../types'
import { getApplicationFlowTheme } from './application-flow-theme'

interface FormChannelPresentationConfig {

  /** 渠道模板；是表单展示版本与主题的唯一选择依据。 */
  channelTemplate?: unknown

  /** 对客品牌字段；当前表单稿没有独立品牌节点，因此不参与主题解析。 */
  showChannelName?: unknown
}

export interface FormPresentation {

  /** 由 channelTemplate 映射出的表单皮肤主题。 */
  theme: ApplicationFlowTheme
}

/**
 * resolveFormPresentation — 将渠道详情映射为表单页可消费的 v2 主题。
 * channelTemplate 是唯一的版本和主题来源，showChannelName 不参与颜色或版本推导；
 * 模板不在 2~6 时返回 null，调用方继续保留旧表单，以免由产品或流程状态猜测展示版本。
 * @param {unknown} detail 渠道详情接口返回的原始配置
 * @returns {FormPresentation | null} 有效的 v2 表单主题，或表示沿用旧表单的 null
 */
export const resolveFormPresentation = (detail: unknown): FormPresentation | null => {
  const config = detail && typeof detail === 'object' ? detail as FormChannelPresentationConfig : null
  const theme = getApplicationFlowTheme(config?.channelTemplate)

  return theme ? { theme } : null
}
